module.exports = __webpack_public_path__ + "media/collapse.786e17d3.mp4";